export const sourcePreviewHeader = {
	title: 'Source Preview',
};
